// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chatCard_container__tPrae, .chatCard_activeContainer__1u8zA {
  width: 100%;
  display: flex;
  height: 50px;
  padding: 0px 10px;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px;
  cursor: default; }
  .chatCard_container__tPrae input, .chatCard_activeContainer__1u8zA input {
    height: 40px;
    border-radius: 4px;
    padding: 4px 4px 4px 4px;
    border-width: 1px;
    border-color: #9e9e9e;
    width: 50%;
    background: rgba(254, 97, 0, 0.1);
    border-color: #666666; }
    .chatCard_container__tPrae input :focus, .chatCard_activeContainer__1u8zA input :focus {
      border-color: #666666; }

.chatCard_activeContainer__1u8zA {
  background: var(--product-akcent-transperent, rgba(254, 97, 0, 0.1)); }

.chatCard_actionsContainer__0II-g {
  display: flex;
  align-items: center;
  justify-content: center;
  column-gap: 8px; }
  .chatCard_actionsContainer__0II-g svg {
    transform: scale(1.2);
    fill: #2c2c2c;
    cursor: pointer; }
`, "",{"version":3,"sources":["webpack://./src/pages/aiChat/components/chatCard/chatCard.module.scss","webpack://./src/styles/common.scss"],"names":[],"mappings":"AAGA;EACE,WAAW;EACX,aAAa;EACb,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,eAAe,EAAA;EARjB;IAUI,YAAY;IACZ,kBAAkB;IAClB,wBAAwB;IACxB,iBAAiB;IACjB,qBAAoC;IACpC,UAAU;IACV,iCAAkC;IAClC,qBAAoC,EAAA;IAjBxC;MAmBM,qBAAoC,EAAA;;AAK1C;EAEE,oEAAqE,EAAA;;AAGvE;EC9BE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;ED8BvB,eAAe,EAAA;EAFjB;IAII,qBAAqB;IACrB,aAAa;IACb,eAAe,EAAA","sourcesContent":["@import '../../../../styles/common.scss';\n@import '../../../../styles/fonts';\n\n.container {\n  width: 100%;\n  display: flex;\n  height: 50px;\n  padding: 0px 10px;\n  align-items: center;\n  justify-content: space-between;\n  border-bottom: 1px;\n  cursor: default;\n  input {\n    height: 40px;\n    border-radius: 4px;\n    padding: 4px 4px 4px 4px;\n    border-width: 1px;\n    border-color: rgba(158, 158, 158, 1);\n    width: 50%;\n    background: rgba(254, 97, 0, 0.10);\n    border-color: rgba(102, 102, 102, 1);\n    :focus {\n      border-color: rgba(102, 102, 102, 1);\n    }\n  }\n}\n\n.activeContainer {\n @extend .container;\n  background: var(--product-akcent-transperent, rgba(254, 97, 0, 0.10));\n}\n\n.actionsContainer {\n  @include flexCenter;\n  column-gap: 8px;\n  svg {\n    transform: scale(1.2);\n    fill: #2c2c2c;\n    cursor: pointer;\n  }\n}","\n@mixin flexCenter {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `chatCard_container__tPrae`,
	"activeContainer": `chatCard_activeContainer__1u8zA`,
	"actionsContainer": `chatCard_actionsContainer__0II-g`
};
export default ___CSS_LOADER_EXPORT___;
